import { default as dashboard } from './dashboard/routes'
import { default as auth } from './auth/routes'
import { default as website } from './website/routes'

export default [ ...auth, ...dashboard, ...website ]



// WEBPACK FOOTER //
// ./src/app/routes.js